import { makeStyles } from '@material-ui/core/styles';
import { flexAlignCenterJustifyCenter } from 'UI/utils/styles';

export const useStyles = makeStyles(theme => ({
  headerAction: {
    '& .MuiCardHeader-action': {
      display: 'flex',
      alignItems: 'center',
      margin: 'auto'
    }
  },
  cardContent: ({ isLoading, shouldSetMinHeight }) => {
    const styles = {
      padding: `${theme.spacing(3, 0)} !important`
    };

    if (shouldSetMinHeight) {
      styles.minHeight = 260;
    }

    return isLoading
      ? {
          ...flexAlignCenterJustifyCenter,
          ...styles
        }
      : styles;
  }
}));
